var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy": "FormStockItemAlternative-customerId",
                      filled: "",
                      label: _vm.$$t("customerCode"),
                      "item-text": "customerDesc",
                      "item-value": "customerId",
                      items: _vm.customers,
                    },
                    on: { change: _vm.customerChanged },
                    model: {
                      value: _vm.localStockItemAlternative.customerId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localStockItemAlternative,
                          "customerId",
                          $$v
                        )
                      },
                      expression: "localStockItemAlternative.customerId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy": "FormStockItemAlternative-stockItemId",
                      filled: "",
                      label: "Stock Item",
                      "item-text": (i) => `${i.itemCode} - ${i.description}`,
                      "item-value": "itemCode",
                      items: _vm.stockItems,
                    },
                    model: {
                      value: _vm.localStockItemAlternative.itemCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.localStockItemAlternative, "itemCode", $$v)
                      },
                      expression: "localStockItemAlternative.itemCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy":
                        "FormStockItemAlternative-alternativeStockItemId",
                      filled: "",
                      label: "Alternative Stock Item",
                      "item-text": (i) => `${i.itemCode} - ${i.description}`,
                      "item-value": "itemCode",
                      items: _vm.stockItems,
                    },
                    model: {
                      value: _vm.localStockItemAlternative.alternativeItemCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localStockItemAlternative,
                          "alternativeItemCode",
                          $$v
                        )
                      },
                      expression:
                        "localStockItemAlternative.alternativeItemCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormStockItemAlternative-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormStockItemAlternative-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }